import React, { useState, useEffect } from 'react';
import "../pages/css/DashBoard.css";
import Header from '../pages/components/HeaderUser';
import SideBar from '../pages/components/SidebarUser';
import UserVerificationUser from '../pages/components/UserVerificationUser';
import { useNavigate } from "react-router-dom";
import { getDatabase, ref, set } from "firebase/database";
import { getAuth } from "firebase/auth";

function ViewPricing() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  UserVerificationUser();
  const toggleSidebar = () => setIsSidebarOpen(prev => !prev);
  const navigate = useNavigate();

  const [prices, setPrices] = useState({
    bitcoin: null,
    ethereum: null,
    tether: null,
  });

  // Fetch prices from CoinGecko
  const fetchPrices = async () => {
    try {
      const ids = "bitcoin,ethereum,tether";
      const resp = await fetch(
        `https://api.coingecko.com/api/v3/simple/price?ids=${ids}&vs_currencies=usd`
      );
      const data = await resp.json();
      setPrices({
        bitcoin: data.bitcoin?.usd ?? null,
        ethereum: data.ethereum?.usd ?? null,
        tether: data.tether?.usd ?? null,
      });
    } catch (err) {
      console.error("Error fetching crypto prices", err);
    }
  };

  useEffect(() => {
    fetchPrices();
    const interval = setInterval(fetchPrices, 10000);
    return () => clearInterval(interval);
  }, []);

  const auth = getAuth();
  const db = getDatabase();

  // Handle Buy Now button
  const handleBuyNow = async (coinId, coinName, price) => {
    if (!auth.currentUser) {
      alert("Please login first.");
      return;
    }

    const uid = auth.currentUser.uid;
    try {
      await set(ref(db, `blackstone-users/${uid}/coinsPricing/${coinId}`), {
        coin: coinName,
        price: price,
        timestamp: new Date().toISOString(),
      });
      navigate("/add-coins");
    } catch (error) {
      console.error("Error saving coin pricing:", error);
    }
  };

  const boxes = [
    {
      id: "bitcoin",
      name: "Bitcoin (BTC)",
      price: prices.bitcoin,
      gradient: "linear-gradient(135deg, #f093fb, #f5576c)",
    },
    {
      id: "ethereum",
      name: "Ethereum (ETH)",
      price: prices.ethereum,
      gradient: "linear-gradient(135deg, #84fab0, #8fd3f4)",
    },
    {
      id: "tether",
      name: "Tether (USDT)",
      price: prices.tether,
      gradient: "linear-gradient(135deg, #a18cd1, #fbc2eb)",
    },
  ];

  return (
    <>
      <div className="d-flex layout-container">
        <SideBar isOpen={isSidebarOpen} />

        <div className="flex-grow-1">
          <Header onMenuClick={toggleSidebar} />
          <div className="scrollable-section p-4">
            <div className="row g-4">
              {boxes.map((box) => (
                <div className="col-md-4" key={box.id}>
                  <div
                    className="d-flex flex-column justify-content-center align-items-center text-white p-4"
                    style={{
                      background: box.gradient,
                      borderRadius: "20px",
                      boxShadow: "0 8px 16px rgba(0,0,0,0.2)",
                      height: "220px",
                      textAlign: "center",
                    }}
                  >
                    <h2>
                      {box.price !== null
                        ? `$ ${box.price.toLocaleString()}`
                        : "Loading..."}
                    </h2>
                    <h5>{box.name}</h5>
                    <p>Live Price (USD)</p>
                    <button
                      className="mt-2 px-4 py-2 text-white"
                      style={{
                        background: "transparent",
                        border: "1px solid rgba(255,255,255,0.7)",
                        borderRadius: "12px",
                        boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
                      }}
                      onClick={() =>
                        handleBuyNow(box.id, box.name, box.price)
                      }
                      disabled={box.price === null}
                    >
                      Buy Now
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewPricing;
